import React from "react";
import UserLayout from "../layout/UserLayout";
import { useSelector } from "react-redux";

const Profile = () => {
    const { user } = useSelector((state) => state.auth);

    return (
        <UserLayout>
            <div className="row align-items-start justify-content-center ">
                {/* Avatar Section */}
                <div className="col-12 col-md-5 text-center mb-4">
                    {/* <figure className="avatar avatar-profile mx-auto">
            <img
              className="rounded-circle img-fluid shadow-sm profile-avatar"
              src={user?.avatar ? user?.avatar?.url : "/images/default_avatar.jpg"}
              alt={user?.name}
              style={{ width: "160px", height: "160px", objectFit: "cover" }}
            />
          </figure> */}
                    <h5 className=" fw-bold text-gradient justify-content-center">👤 {user?.name}</h5>
                </div>

                {/* Info Section */}
                <div className="col-12 col-md-7 " style={{maxWidth: "25rem"}}>
                    <div className=" card shadow-sm rounded-4 p-4  border-0 ">
                        <h4 className="fw-bold mb-4 text-gradient" >Profile Details</h4>

                        <div className="mb-3">
                            <h6 className="text" style={{ color: "#e04f6ecd" }}>Full Name</h6>
                            <p className="fw-semibold" style={{ color: "#e04f6ecd" }}>{user?.name}</p>
                        </div>

                        <div className="mb-3">
                            <h6 className="text"style={{ color: "#e04f6ecd" }} >Email Address</h6>
                            <p className="fw-semibold" style={{ color: "#e04f6ecd" }}>{user?.email}</p>
                        </div>

                        <div>
                            <h6 className="text" style={{ color: "#e04f6ecd" }}>Joined On</h6>
                            <p className="fw-semibold" style={{ color: "#e04f6ecd" }}>{user?.createdAt?.substring(0, 10)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </UserLayout>
    );
};

export default Profile;
